export const detectBrowser = () => {
  const ua = navigator.userAgent;

  if (/edg/i.test(ua)) return "Edge";
  if (/chrome|chromium|crios/i.test(ua)) return "Chrome";
  if (/firefox|fxios/i.test(ua)) return "Firefox";
  if (/safari/i.test(ua) && !/chrome|chromium/i.test(ua)) return "Safari";
  if (/opr\//i.test(ua)) return "Opera";
  if (/trident/i.test(ua)) return "IE";

  return "Unknown";
};

export const SAFARI_BROWSER = "Safari";
export const CHROME_BROWSER = "Chrome";
